import ajax from "@/lib/ajax/index";
import i18n from "@/i18n";
import { recursionTrans } from "@/views/zhiji/js/common/util";

function getOperationBtn(status) {
    return [
        {
            label: status ? "下线" : "上线",
            value: status ? "off" : "on"
        },
        {
            label: "修改优先级",
            value: "updateWeight"
        },
        {
            label: "删除",
            value: "del"
        }
    ];
}

function transTreesData(result) {
    const cvtTreeData = recursionTrans(
        result,
        function(treesData) {
            return {
                id: "" + treesData.classify_id,
                smallLabel: "" + treesData.classify_id,
                label: treesData.classify_name,
                level: treesData.classify_level,
                editFlags: ["add", "edit", "delete"]
            };
        },
        "nodes",
        "children"
    );
    return {
        label: i18n.t("zhiji.common.allClassify"),
        id: "-1",
        smallLabel: "",
        children: cvtTreeData
    };
}

// 获取实体分类列表
export async function queryEntityClasses(reqData) {
    const res = await ajax.get("/xiaoyue-operation/entity_words/classify/list", {
        game_id: reqData.gameId,
        classify_name: reqData.classifyName
    });
    const treesData = transTreesData(res)

    return {
        treesData
    };
}

// 新增实体分类
export async function addEntityClasses(reqData) {
    const params = {
        game_id: reqData.gameId,
        classify_name: reqData.classifyName,
        parent_classify_id: reqData.parentClassifyId
    };
    await ajax.post("/xiaoyue-operation/entity_words/classify/add", params);
}

// 编辑实体分类
export async function editEntityClasses(reqData) {
    const params = {
        game_id: reqData.gameId,
        classify_id: reqData.classifyId,
        classify_name: reqData.classifyName
    };
    await ajax.post("/xiaoyue-operation/entity_words/classify/update", params);
}

// 删除实体分类
export async function deleteEntityClasses(reqData) {
    const params = {
        game_id: reqData.gameId,
        classify_id: reqData.classifyId,
    };
    await ajax.post("/xiaoyue-operation/entity_words/classify/delete", params);
}

// 实体组列表
export async function queryEntitylist(reqData) {
    const params = {
        game_id: reqData.gameId,
        classify_id: reqData.classifyId,
        page: reqData.page || 1,
        size: reqData.size || 10
    };
    reqData.status && (params.status = reqData.status);

    if (reqData.keyWordSearch && reqData.keyWordSearch.keyWord) {
        params.search_type = reqData.keyWordSearch.type;
        params.keyword = reqData.keyWordSearch.keyWord;
    }

    const { count, online_count, offline_count, list = [] } = await ajax.get("/xiaoyue-operation/entity_words/group/list", params);
    return {
        count,
        onlineCount: online_count,
        offlineCount: offline_count,
        list: list.map(item => ({
            ...item,
            creator: item.creator + "\n" + item.create_time,
            operator: item.operator + "\n" + item.update_time,
            relationQuestion: item.question_id + "\n" + item.question_name,
            editable: false,
            classify_id: item.classify_id.toString(),
            mapStatus: {
                text: item.status ? "● 已上线" : "● 未上线",
                color: item.status ? "#00cd68" : "#7a7f8f"
            },
            operation: getOperationBtn(item.status)
        }))
    };
}

// 新增实体组
export async function addEntity(reqData) {
    const params = {
        game_id: reqData.gameId,
        entity_group_name: reqData.entityGroupName, //实体组名称
        question_id: reqData.questionId, //兜底标问id
        classify_id: reqData.classifyId, //分类id
        status: reqData.status,
        entity_list: reqData.entityList // 实体集合
    };
    await ajax.post("/xiaoyue-operation/entity_words/group/add", params);
}

// 编辑实体组
export async function editEntity(reqData) {
    const params = {
        game_id: reqData.gameId,
        entity_group_id: reqData.entityGroupId, //实体组id
        entity_group_name: reqData.entityGroupName, //实体组名称
        question_id: reqData.questionId, //兜底标问id
        classify_id: reqData.classifyId, //分类id
        status: reqData.status,
        entity_list: reqData.entityList // 实体集合
    };
    await ajax.post("/xiaoyue-operation/entity_words/group/update", params);
}

// 删除实体组
export async function deleteEntity(reqData) {
    const params = {
        game_id: reqData.gameId,
        entity_group_ids: reqData.entityGroupId
    };
    await ajax.post("/xiaoyue-operation/entity_words/group/delete", params);
}

// 修改实体组状态
export async function updateEntityStatus(reqData) {
    const params = {
        game_id: reqData.gameId,
        entity_group_ids: reqData.entityGroupId,
        status: reqData.status
    };
    await ajax.post("/xiaoyue-operation/entity_words/group_status/update", params);
}

// 转移实体组
export async function transferEntity(reqData) {
    const params = {
        game_id: reqData.gameId,
        entity_group_ids: reqData.entityGroupId,
        classify_id: reqData.classifyId,
    };
    await ajax.post("/xiaoyue-operation/entity_words/group_classify/transfer", params);
}

// 修改实体组权重优先级
export async function updateEntityWeight(reqData) {
    const params = {
        game_id: reqData.gameId,
        entity_group_id: reqData.entityGroupId,
        weight: reqData.weight
    };
    await ajax.post("/xiaoyue-operation/entity_words/group_weight/update", params);
}

// 导入实体组
export async function importEntityApi(reqData) {
    await ajax.post("/xiaoyue-operation/entity_words/import", reqData, { stringify: str => str });
}

// 导入实体任务列表
export async function importEntityList(reqData) {
    const params = {
        game_id: reqData.gameId,
        page: reqData.page,
        size: reqData.size
    };
    const { count, list } = await ajax.get("/xiaoyue-operation/entity_words/import/list", params);
    return {
        count,
        list
    };
}

// 导出实体组
export async function exportEntityApi(reqData) {
    const params = {
        game_id: reqData.gameId,
        page: reqData.page || 1,
        size: reqData.size || 10,
        classify_id: reqData.classifyId
    };
    reqData.status && (params.status = reqData.status);

    if (reqData.keyWordSearch && reqData.keyWordSearch.keyWord) {
        params.search_type = reqData.keyWordSearch.type;
        params.keyword = reqData.keyWordSearch.keyWord;
    }
    await ajax.post("/xiaoyue-operation/entity_words/export", params);
}

// 导出实体任务列表
export async function exportEntityList(reqData) {
    const params = {
        game_id: reqData.gameId,
        page: reqData.page,
        size: reqData.size
    };
    const { count, list } = await ajax.get("/xiaoyue-operation/entity_words/export/list", params);
    return {
        count,
        list
    };
}
